enum SUBSCRIPTION_ACTION_TYPES {
	GET_SUBSCRIPTION_PRICES = 'GET_SUBSCRIPTION_PRICES',
	GET_SUBSCRIPTION_PRICES_SUCCESS = 'GET_SUBSCRIPTION_PRICES_SUCCESS',
	GET_SUBSCRIPTION_PRICES_ERROR = 'GET_SUBSCRIPTION_PRICES_ERROR',
}

export default SUBSCRIPTION_ACTION_TYPES;
